import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const links: AdminBlockTypeAttribute = {
  label: 'Show links',
  key: 'links',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default links;
